// @module Katoomi.Shiphawk.Shopping
define('Katoomi.Shiphawk.Shopping.View'
,	[
	'katoomi_shiphawk_shopping.tpl'
	

	,	'Backbone'
    ]
, function (
	katoomi_shiphawk_shopping_tpl
	

	,	Backbone
)
{
    'use strict';

	// @class Katoomi.Shiphawk.Shopping.View @extends Backbone.View
	return Backbone.View.extend({

		template: katoomi_shiphawk_shopping_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new ShoppingModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Katoomi.Shiphawk.Shopping.View.Context
	,	getContext: function getContext()
		{
			//@class Katoomi.Shiphawk.Shopping.View.Context
			this.message = this.message || 'Hello Shopping!!'
			return {
				message: this.message
			};
		}
	});
});
